import { render, staticRenderFns } from "./wait-refund-order.vue?vue&type=template&id=a08cc364&"
import script from "./wait-refund-order.vue?vue&type=script&lang=js&"
export * from "./wait-refund-order.vue?vue&type=script&lang=js&"
import style0 from "./wait-refund-order.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports